import { AIconSize } from '../../atoms/AIcon/AIcon.types';

export enum MCarouselControlsType {
  Dots = 'dots',
  Numbers = 'numbers',
}

export interface MCarouselControlsAIcon {
  icon: string;
  size?: AIconSize;
}

export interface MCarouselControlsProps {
  type?: MCarouselControlsType;
  imageOverlay?: boolean;
  totalSlides?: number;
  currentSlide?: number;
  onNext?: () => void;
  onPrev?: () => void;
  aIcon?: MCarouselControlsAIcon;
  className?: string;
  arrows?: boolean;
}
